module.exports = __webpack_public_path__ + "static/img/tutorial-tool-attraction-3.3e0223f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-tool-attraction-3.jpg
// module id = 4fS2
// module chunks = 3